// src/constants/paths.ts
export const PUBLIC_IMAGE_PATH = `${process.env.PUBLIC_URL}/images`;
export const PUBLIC_MOVIE_PATH = `${process.env.PUBLIC_URL}/movies`;
export const PUBLIC_LOTTIE_PATH = `${process.env.PUBLIC_URL}/lotties`;
export const PUBLIC_SVG_PATH = `${process.env.PUBLIC_URL}/svgs`;
